goog.provide('gcmBridge');
goog.require('gcm.urlutil');
goog.require('gcm.validate');
// required xmlutil in gcm bridge to expose gcm utility to games.
goog.require('gcm.xmlutil');
// TODO move into main src/main/javascript/openbet/gcm directory.

/**
 * Game Client Middleware Bridge is available for game suppliers as a bridge
 * into the gcm module.<br>
 * GCM. Game Client Middleware<br>
 * (C) 2012 OpenBet Technologies Ltd. All rights reserved.<br>
 * <p>
 * The gcm module itself will reside in the commonUI iframe. gcmBridge takes care
 * of creating the iframe for the commonUI, loading the commonUI into it, then
 * once gcm is loaded into the commonUI iframe, gcmBridge will allow the game to
 * communicate with gcmBridge as if it were gcm itself. This way the game does
 * not need to know about the iframe details. gcmBridge will also manage the
 * iframe sizing: The commonUI will ask gcm to resize the commonUI iframe at
 * different times in order to show different sized displays over the game. gcm
 * will call through to gcmBridge to adjust the size of the iframe.
 * </p>
 *
 * @author asugar
 * @namespace
 */
var gcmBridge = {};

/**
 * @type {?string}
 * @private
 */
gcmBridge.gameName_;

/**
 * @type {?string}
 * @private
 */
gcmBridge.channel_;

/**
 * @type {?string}
 * @private
 */
gcmBridge.device_;

// TODO create enum for playMode
/**
 * @type {?string}
 * @private
 */
gcmBridge.playMode_;

/**
 * @type {?string}
 * @private
 */
gcmBridge.language_;

/**
 * @type {Element}
 * @private
 */
gcmBridge.ifrm_;
// TODO: change this to proper type {Gcm}
/**
 * @type {Object}
 * @private
 */
gcmBridge.gcm_;

// TODO: change this to proper type {Game}
/**
 * @type {Object}
 * @private
 */
gcmBridge.game_;

/**
 * @type {boolean}
 * @private
 */
gcmBridge.xmlResponse_;

/**
 * @type {Object}
 * @private
 */
gcmBridge.callback_;

/**
 * @type {string}
 * @private
 */
gcmBridge.wsBaseURL_;

/**
 * @type {string}
 */
gcmBridge.overrideURL;


/**
 * @type {string}
 */
gcmBridge.cmaBridgeConfigScriptURL = '../../cma/js/cmaBridgeConfig.js';

/**
 * checks if the uri paramater is a relative URI
 * This function protects us from
 * the potential security risk of rendering absolue url content that has been
 * specified as a request param
 * Note that not all relative URIs are allowed, but we do reject absolute URIs and
 * network-path references.
 * @param {string} url the URL to check.
 * @return {boolean} is this a relative url.
 */
gcmBridge.checkURIIsRelative = function(url) {
  return UrlUtil.checkURIIsRelative(url);
};

// TODO: proper type for this object
/**
 * The game should call this init method on the gcmBridge as soon as possible
 * Here we create an iframe and load the commonUI into it.
 * For getting the gcm parameter's values, first gcmParams parameter's value will be
 * fetched from URL using UrlUtil.getSearchParameterByName function. Using the gcmParams value, all
 * the gcm parameters and its related values will be fetched. The example gcmParams is detailed below:
 *
 * gcmParams=gcmPlayMode%3Dreal|
 *           gcmChannel%3DI|
 *           gcmGameName%3Dgcm-example-game|
 *           gcmLang%3Den|
 *           gcmCommonUIURL%3D%2Fgcm-tests%2Fgcm-example-commonui%2Fcommonui.html
 * The gcmParams variable is passed into UrlUtil.getGCMParams function and this functions returns
 * gcmParamsObject which contains the decoded gcm parameters and its values. For example, the gameName
 * can be retrieved from gcmParamsObject like gcmParamsObject['gameName'].Similarly other parameters such as
 * channel, playMode, lang and commonUIURL can also be accessed.
 *
 * @param {Element} docBody document.body for the page. Used to create the
 *          iframe for the commonUI.
 * @param {string} currentUrl the full url of the game window, including the parameters:
 *          gcmParams.This parameter is extracted by gcmBridge and must be included for the currentUrl to be valid.
 *          The game should pass the entire game launch URL in the currentURL parameter.
 *          From this gcmParams, PlayMode, channel, gameName, lang and commonUIURL values can be obtained.
 * @param {Object} game this is the game object. gcmBridge will call gcmReady on
 *          it, once gcm is available.
 */
gcmBridge.init = function(docBody, currentUrl, game) {
  if (!gcm.validate.isElement(docBody)) {
    throw new Error('gcmBridge.init: Invalid argument docBody - not an Element');
  }
  if (typeof (currentUrl) !== 'string') {
    throw new Error(
        'gcmBrdige.init: Invalid argument currentUrl - not a String');
  }
  var gameCheck = gcm.validate.isGame(game);
  if (gameCheck.length > 0) {
    throw new Error('gcmBrige.init: Game Missing API Methods:' + gameCheck.toString());
  }
  gcmBridge.game_ = game;

  var gcmParams = UrlUtil.getSearchParameterByName('gcmParams', currentUrl);

  if (gcmParams != null) {
    var gcmParamsObject = new Array();
    gcmParamsObject = UrlUtil.getGCMParams(gcmParams);

    gcmBridge.gameName_ = gcmParamsObject['gameName'];
    if (gcmBridge.gameName_ === null) {
      throw new Error('gcmBridge.init: gameName has not been supplied in gcmParams');
    } else {
      if (!gcm.validate.isValidGameName(gcmBridge.gameName_)) {
        throw new Error(
          'gcmBridge.init: gameName request parameter is not alphanumeric string');
        }
    }

    gcmBridge.language_ = gcmParamsObject['lang'];
    if (gcmBridge.language_ === null) {
      throw new Error('gcmBridge.init: lang has not been supplied in gcmParams');
    } else {
      if (!gcm.validate.isValidLanguage(gcmBridge.language_)) {
        throw new Error(
          'gcmBridge.init: lang request parameter is neither language nor locale');
        }
    }    

    gcmBridge.channel_ = gcmParamsObject['channel'];
    if (gcmBridge.channel_ === null) {
      throw new Error('gcmBridge.init: channel has not been supplied in gcmParams');
    } else {
      if (!gcm.validate.isSingleLetter(gcmBridge.channel_) && !gcm.validate.isSingleDigit(gcmBridge.channel_)) {
        throw new Error(
          'gcmBridge.init: channel request parameter is not a single letter or a single digit');
      }
    }

    gcmBridge.playMode_ = gcmParamsObject['playMode'];
    if (gcmBridge.playMode_ === null) {
      throw new Error('gcmBridge.init: gcmPlayMode has not been supplied in gcmParams');
    } else {
      // check that playMode is one of these: demo/real
      if (!(gcmBridge.playMode_ === 'demo' || gcmBridge.playMode_ === 'real')) {
        throw new Error(
          'gcmBridge.init: playMode request parameter is none of these: demo/real');
      }
    }

    var commonUIUrl = gcmParamsObject['commonUIURL'];
    if (commonUIUrl === null) {
    throw new Error(
      'gcmBridge.init: gcmCommonUIURL has not been supplied in gcmParams');
    }
  } else {
      throw new Error('gcmBridge.init: gcmParams request parameter has not been supplied');
  }

  var reqParams = {
    'gameName': gcmBridge.gameName_,
    'playMode': gcmBridge.playMode_,
    'channel': gcmBridge.channel_,
    'device' : gcmBridge.device_
  };

  var commonUIUrlParams = UrlUtil.addParametersToUrl(commonUIUrl, reqParams);

  // initially we want the commonUI to take up the whole screen
  // by default for loading sequence
  // check the commonUI url is relative before loading
  // note that it is a security risk to allow absolute paths to be rendered
  // that have been passed in as request parameters
  if (gcmBridge.checkURIIsRelative(commonUIUrl)) {
    if(!gcmBridge.isDesktop()) {
      gcmBridge.makeIFrame_(docBody, commonUIUrlParams, 100, 100);
    } 
  } else {
    throw new Error(
        'gcmBridge.init: commonUIURL request parameter is not a relative URL');
  }

  if(gcmBridge.isDesktop()) {
    //gcmBridge.gcm_ = parent.com.openbet.gcm;
    gcmBridge.gcm_ = goog.getObjectByName('com.openbet.gcm', window.parent);
    // the gcm object
    gcmBridge.game_.gcmReady(gcmBridge.gcm_);
    //inform gcm that game is available and pass through the game object    
    gcmBridge.gcm_.setGame(gcmBridge.game_);
    gcmBridge.gcm_.gameConfigReady();
  }

};

/**
 * create an iframe and add to document body
 * @param {Element} docBody the document body Element.
 * @param {string} url the url to load into the iframe.
 * @param {number} widthPct initial width percentage.
 * @param {number} heightPct initial height percentage.
 * @private
 */
gcmBridge.makeIFrame_ = function(docBody, url, widthPct, heightPct) {
  gcmBridge.ifrm_ = document.createElement('iframe');
  gcmBridge.ifrm_.name = 'commonUIIFrame';
  gcmBridge.ifrm_.setAttribute('src', url);
  gcmBridge.ifrm_.style.width = widthPct + '%';
  gcmBridge.ifrm_.style.height = heightPct + '%';
  gcmBridge.ifrm_.style.position = 'absolute';
  gcmBridge.ifrm_.setAttribute('scrolling', 'no');
  gcmBridge.ifrm_.style.border = 0;
  gcmBridge.ifrm_.style.top = 0;
  gcmBridge.ifrm_.style.left = 0;
  gcmBridge.ifrm_.style.zIndex = 999999;
  docBody.appendChild(gcmBridge.ifrm_);
};

// TODO: change this to proper type {GCM}
/**
 * gcm will call this method when it is ready
 * @param {Object} gcm - the gcm object from the iframe.
 */
gcmBridge.gcmReady = function(gcm) {
  gcmBridge.gcm_ = gcm;
  //inform gcm that game is available and pass through the game object
  gcmBridge.gcm_.setGame(gcmBridge.game_);
  // the gcm object
  gcmBridge.game_.gcmReady(gcmBridge.gcm_);
};

/**
 * GCM will call through to the gcm bridge when the commonUI iframe needs to be
 * resized
 *
 * @param {string} height new height of iframe in any css unit, e.g. "20%",
 *          "20px", "20em" are all valid.
 * @param {string} width (Optional) The new width of iframe, same format as height.
 * @param {string} offsetX Gap between top/bottom and start of the iframe.
 * @param {string} offsetY Gap between sides and start of the iframe.

 */
gcmBridge.commonUIResize = function(height, width, offsetX, offsetY) {

  if (!gcm.validate.isHeight(height)) {
    throw new Error('gcmBridge.commonUIResize: Invalid height value ' + height);
  }

  if (offsetX && offsetY)
  {
    gcmBridge.ifrm_.style.height = height;
    gcmBridge.ifrm_.style.width = width;
    gcmBridge.ifrm_.style.left = offsetX;
    gcmBridge.ifrm_.style.top = offsetY;
    gcmBridge.ifrm_.style.marginLeft = 0;
  }
  else
  {
  if (height)
    gcmBridge.ifrm_.style.height = height;
  if (width)
  {
    gcmBridge.ifrm_.style.width = width;
    var currentWidth = gcmBridge.ifrm_.offsetWidth;
    gcmBridge.ifrm_.style.left = '50%';
    gcmBridge.ifrm_.style.marginLeft = (-currentWidth / 2) + 'px';
    }
  }
};

/**
 * Returns the playMode included in the launching url parameters.  Used by GCM.<br>
 * This value has been stored during the gcm.init call
 * @return {?string} playMode.
 */
gcmBridge.getPlayMode = function() {
  return gcmBridge.playMode_;
};

/**
 * Returns the channel included in the launching url parameters.  Used by GCM.<br>
 * This value has been stored during the gcm.init call
 * @return {?string} channel.
 */
gcmBridge.getChannel = function() {
  return gcmBridge.channel_;
};

/**
 * Returns the gameName included in the launching url parameters.  Used by GCM.<br>
 * This value has been stored during the gcm.init call
 * @return {?string} gameName.
 */
gcmBridge.getGameName = function() {
  return gcmBridge.gameName_;
};

/**
 * Returns the language included in the launching url parameters.  Used by GCM.<br>
 * This value has been stored during the gcm.init call
 * @return {?string} language.
 */
gcmBridge.getLanguage = function() {
  return gcmBridge.language_;
};

gcmBridge.isDesktop = function() {
    return gcmBridge.device_ === "desktop" || (!gcmBridge.device_ && window.parent !== window);
};


/**
 * This function is called by the game before initing GCMBridge, GCMBridge calls the passed callback function with the WS response
 * This function has the hardcoded path to the WS base as "/gcm-ws/". 
 * This is the standard path of the webservices deployment. 
 * If the operator chooses to deploy it in another path, this will need to be configured. 
 * Since this function call takes place very early in the launch sequence before everything is initialized. 
 * This override takes place inside this function. The function looks for the existence of the an override.js in the same directory as the gcmBridge.js. 
 * If no override.js is provided you may see a failed HEAD request which should be harmless. 
 * If the override.js exists, gcmBridge will use the path defined in that. Override.js contains a single line of code as this:
 * com.openbet.gcmBridge.overrideURL = <path to the gcm webservices as string>;
 * @param {Function} callback The function to call when GCMBridge receives WS response for GCM params.
 * @param {boolean} xmlResponse false for json, true for xml response.
 */
gcmBridge.getGCMParams = function(callback, xmlResponse) {

  var scripts = document.getElementsByTagName('script');
  var scriptsLength = scripts.length;
  var regex = /gcmBridge\.js$/;          

  for (var i = 0; i < scriptsLength; i++) {
    var src = scripts[i].src;
    if (src && src.match(regex)) {
      var originalJSPath = src.slice(0, src.lastIndexOf('/'));
      break;
    }
  }
 
  gcmBridge.callback_ = callback;
  gcmBridge.xmlResponse_ = xmlResponse;
  gcmBridge.wsBaseURL_ = "/gcm-ws/";  

  var fileref = document.createElement('script');
  fileref.setAttribute("src", originalJSPath + "/override.js");
  fileref.onload = function () {
    gcmBridge.wsBaseURL_ = goog.getObjectByName("com.openbet.gcmBridge").overrideURL;
    gcmBridge.getGCMParamsWS();  
  };

  if(!gcmBridge.urlExists(originalJSPath + "/override.js")) {
    gcmBridge.getGCMParamsWS();
  } else {
    document.head.appendChild(fileref);   
  }
  
};



goog.exportSymbol('com.openbet.gcmBridge.isDesktop', gcmBridge.isDesktop);
goog.exportSymbol('com.openbet.gcmBridge.getGameName', gcmBridge.getGameName);
goog.exportSymbol('com.openbet.gcmBridge.getLanguage', gcmBridge.getLanguage);
goog.exportSymbol('com.openbet.gcmBridge.getChannel', gcmBridge.getChannel);
goog.exportSymbol('com.openbet.gcmBridge.getPlayMode', gcmBridge.getPlayMode);
goog.exportSymbol('com.openbet.gcmBridge.commonUIResize', gcmBridge.commonUIResize);
goog.exportSymbol('com.openbet.gcmBridge.gcmReady', gcmBridge.gcmReady);
goog.exportSymbol('com.openbet.gcmBridge.init', gcmBridge.init);
goog.exportSymbol('com.openbet.gcmBridge.checkURIIsRelative', gcmBridge.checkURIIsRelative);
goog.exportSymbol('com.openbet.gcmBridge.getGCMParams', gcmBridge.getGCMParams);
goog.exportSymbol('com.openbet.gcmBridge.overrideURL', gcmBridge.overrideURL);

gcmBridge.urlExists= function(url)
{
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    http.send();
    return (http.status === 200);
}

gcmBridge.getGCMParamsWS = function() {


      var xmlhttp = gcmBridge.createHttpRequestObj();
      var currentUrl = window.location.href;
      var gcmParams = UrlUtil.getSearchParameterByName('gcmParams', currentUrl);

      var gcmParamsObject = new Array();

      if (gcmParams != null) {
        gcmParamsObject = UrlUtil.getGCMParams(gcmParams);
        gcmBridge.gameName_ = gcmParamsObject['gameName'];
      }

      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
            gcmBridge.handleSimpleWSResponse(xmlhttp.responseText);
        }
      };
      if(gcmBridge.checkURIIsRelative(gcmBridge.wsBaseURL_ )){

        var responseType = ".json";
        if (gcmBridge.xmlResponse_) {
          responseType = ".xml";
        }

        var request = gcmBridge.wsBaseURL_ + 'config/' + gcmBridge.gameName_ + "/simple" + responseType;
        request = UrlUtil.addParametersToUrl(request, gcmParamsObject);
        xmlhttp.open('GET', request, true);
        xmlhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xmlhttp.send();        

      } else {

        throw new Error("gcmBridge.getGCMParamsWS: gcmBridge.wsBaseURL_ is not a relative URL");

      }

  };

gcmBridge.handleSimpleWSResponse = function(response) {    
    if (gcmBridge.xmlResponse_) {
      if ( window.DOMParser ) { // Standard
          var xmlParser = new DOMParser();
          var xmlData = xmlParser.parseFromString( response , "text/xml" );
      } else { // IE
          var xmlData = new ActiveXObject( "Microsoft.XMLDOM" );
          xmlData.async = "false";
          xmlData.loadXML( response );
      }
      gcmBridge.callback_.call(null, xmlData);
    } else {
      gcmBridge.callback_.call(null, window.JSON.parse(response));
    }
  };

gcmBridge.createHttpRequestObj = function() {
      if (window.XMLHttpRequest) {// code for IE7+, Firefox, Chrome, Opera, Safari
        return new XMLHttpRequest();
      }
      else {// code for IE6, IE5
        return new ActiveXObject('Microsoft.XMLHTTP');
      }
  };

/**
 * Helper method to load script into game window.
 * @private
 * @param {string} url.
 * @param {?Function} callback function call when script is loaded.

 */
gcmBridge.loadCustomScript = function(url, callback) {
  var script = document.createElement('script');
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('src', url);
  if(callback) {
    script.onload = callback;
  }
  document.head.appendChild(script);
};

gcmBridge.setupBedeCMA = function() {
  if(CMABridgeConfig) {
    var siteName = UrlUtil.getSearchParameterByName('site', window.location.search);
    if(siteName) {
      var bedeBridgeUrl = CMABridgeConfig['getBridgeScriptUrl']('bede', siteName);
      gcmBridge.loadCustomScript(bedeBridgeUrl);
    } else {
      throw new Error('Url parameter site not set. Skipping bede CMA script load');
    }
  } else {
    throw new Error('Failed to initialize CMABridgeConfig file. Skipping bede CMA script load');
  }
};

// Check if gameUrl has url param named 'bridgeScriptUrl', it indicates Bede CMA.
var bedeCMA= UrlUtil.getSearchParameterByName('bridgeScriptUrl', window.location.search);
if (bedeCMA) {
  // First load the CMA configuration file in order to read bede's bridge script url.
  gcmBridge.loadCustomScript(gcmBridge.cmaBridgeConfigScriptURL, gcmBridge.setupBedeCMA);
}
